import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';

import { getCMSObject, TeleScript } from 'sg-ui-components';

const Error = ({ entry, drawTicket, animation }) => {
    const [promotion, setPromotion] = useState();
    const [points, setPoints] = useState();
    const [isSuccess, setIsSuccess] = useState();
    const [message, setMessage] = useState();

    useEffect(() => {
        if (drawTicket.success) {
            setPromotion(entry?.last_entry?.game?.game_name);
            setPoints(entry?.last_entry?.points * entry?.last_entry?.multiplier);
        }
        setMessage(drawTicket.message);
        setIsSuccess(drawTicket.success);
    }, [drawTicket]);

    const successAlert = () => {
        return animation?.gameUrl?.game ? null : (
            <div className={`alert text-center entry-alert alert-success`} role='alert'>
                <h2 className='text-uppercase'>Success!</h2>
                <TeleScript
                    line={getCMSObject('data.microsite.general.ticketEntry.ticketEntrySuccess.contentHTML')}
                    replace={{
                        '%PROMOTION_NAME%': promotion,
                        '%ENTRIES_AWARDED%': points,
                    }}
                />
            </div>
        );
    };

    const errorAlert = () => <div className={'alert text-center entry-alert alert-danger'} role='alert' dangerouslySetInnerHTML={{ __html: message }} />;

    return message ? isSuccess ? successAlert() : errorAlert() : <></>;
};

export default connect(mapStateToProps, mapDispatchToProps)(Error);
